import React from "react";
import { ControlLabel, Button, Alert, FormControl, Modal } from "react-bootstrap";
import ajax from "./../lib/ajax.js";
import context from "./../lib/context.js";
import immutable from 'immutable';
import { browserHistory } from "react-router";

export default class ActivateUser extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showAgreement: false,
            agreement: '',
            userId: 0,
            userName: '',
            newPassword: '',
            confirmPassword: '',
            fullName: '',
            errorMessage: '',
            errors: []
        };

        this.newPasswordChange = this.newPasswordChange.bind(this);
        this.confirmPasswordChange = this.confirmPasswordChange.bind(this);
        this.agreeClick = this.agreeClick.bind(this);
        this.activateClick = this.activateClick.bind(this);
        this.loadViewModel = this.loadViewModel.bind(this);
    }

    componentWillMount() {
        const self = this;
        const msgCode = self.props.location.query.msgcode;

        if (msgCode) {
            let msg = context.resolveMsg(msgCode);
            if (msg) {
                let clone = immutable.fromJS(self.state);
                clone.errors = [msg];
                self.setState(clone);
            }
        }
    }

    componentDidMount() {
        this.loadViewModel();
    }

    loadViewModel() {
        let self = this;

        context.message({
            show: true,
            type: "loading",
            message: "Loading. Please wait..."
        });

        ajax.vm().get(`activate-user/${self.props.params.token}`)
            .then(function (res) {
                if (res.data.isActivated) {
                    context.message({
                        show: true,
                        type: "info",
                        message: "User is already activated",
                        buttons: "close"
                    },
                    function() { 
                        browserHistory.push(context.routeUrl('login')); 
                    });
                }
                else {
                    self.setState({
                        userId: res.data.userId,
                        userName: res.data.userName,
                        fullName: res.data.fullName,
                        agreement: res.data.agreement,
                        showAgreement: true
                    });
                    context.message({ show: false });
                }
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                },
                function() { 
                    browserHistory.push(context.routeUrl('login')); 
                });
            });
    }

    newPasswordChange(event) {
        let value = event.target.value.trim();
        this.setState({
            newPassword: value
        });
    }

    confirmPasswordChange(event) {
        let value = event.target.value.trim();
        this.setState({
            confirmPassword: value
        });
    }

    agreeClick() {
        this.setState({
            showAgreement: false
        });
    }

    activateClick() {
        // no password validation because it uses Active Directory
        //var messages = this.validate();
        var messages = [];
        this.setState({
            errors: messages,
            reportData: null
        });

        if (messages.length == 0) {
            this.activate();
        }
    }

    activate() {
        let self = this;

        context.message({
            show: true,
            type: "loading",
            message: "Activating. Please wait..."
        });

        ajax.api().post(`activate-user`,
                {
                    token: self.props.params.token,
                    newPassword: self.state.newPassword
                }
            )
            .then(function (res) {
                if (res.data.isActivated) {
                    context.message({
                        show: true,
                        type: "info",
                        message: "User activated successfully",
                        buttons: "close"
                    },
                    function() {
                        browserHistory.push(context.routeUrl('login'));
                    });
                }
                else if (res.data.errorMessage !== undefined && res.data.errorMessage != '') {
                    let msg = [];
                    msg.push(res.data.errorMessage);
                    self.setState({
                        errors: msg
                    });
                    context.message({ show: false });
                }
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    validate() {
        let msg = [];

        if (this.state.newPassword.length == 0) {
            msg.push('New password is required');
        }

        if (this.state.confirmPassword.length == 0) {
            msg.push('Please confirm password');
        }

        if (this.state.newPassword != this.state.confirmPassword) {
            msg.push('Passwords did not match');
        }

        return msg;
    }

    render() {
        var rowStyle = {
            "padding-top": "10px"
        };
        const self = this;
        return (
            <div>
                <section className="ap-l-section ap-section-hero login">
                    <div className="container">
                        <div className="row">
                            <h2 className="text-center">Account Activation</h2>
                        </div>
                        <div className="row">
                            <div className="col-md-offset-2 col-lg-offset-2 col-md-8 col-lg-8">
                                Welcome <b>{self.state.fullName}</b>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-offset-2 col-lg-offset-2 col-md-8 col-lg-8">
                                You will need to activate your account before you can log into the system. You only need to this once.
                            </div>
                        </div>
                        <div className="row" style={rowStyle}>
                            <div className="col-md-offset-2 col-lg-offset-2 col-md-8 col-lg-8">
                               Please verify the information below and click 'Activate Account' to proceed.
                            </div>
                        </div>
                        <div className="row" style={rowStyle}>
                            <div onKeyUp={(evt) => {
                                if (evt.keyCode === 13) self.activateClick();
                            }} className="container-fluid">
                                <div className="row">
                                    <div className="col-md-offset-2 col-lg-offset-2 col-md-4 col-lg-4">
                                        Your email address is:
                                    </div>
                                    <div className="col-md-4 col-lg-4">
                                        <b>{self.state.userName}</b>
                                    </div>
                                </div>
                                <div className="row hide" style={rowStyle}>
                                    <div className="col-md-offset-2 col-lg-offset-2 col-md-4 col-lg-4">
                                        Please type new password (6 to 10 characters):
                                    </div>
                                    <div className="col-md-4 col-lg-4">
                                        <FormControl type="password" placeholder="New Password"
                                            defaultValue={self.state.newPassword}
                                            onChange={self.newPasswordChange}
                                            className="login-input"></FormControl>
                                    </div>
                                </div>
                                <div className="row hide">
                                    <div className="col-md-offset-2 col-lg-offset-2 col-md-4 col-lg-4">
                                        Please re-type new password:
                                    </div>
                                    <div className="col-md-4 col-lg-4">
                                        <FormControl type="password" placeholder="Re-type Password"
                                            defaultValue={self.state.confirmPassword}
                                            onChange={self.confirmPasswordChange}
                                            className="login-input"></FormControl>
                                    </div>
                                </div>
                                <div className="row" style={rowStyle}>
                                    <div className="col-md-offset-2 col-lg-offset-2 col-md-8 col-lg-8">
                                        <Button onClick={self.activateClick} className="btn btn-info ap-fullsize">Activate Account</Button>
                                    </div>
                                    <div className="col-md-4 col-lg-4"></div>
                                </div>
                                <div className="row" style={rowStyle}>
                                    <div className="col-md-offset-2 col-lg-offset-2 col-md-8 col-lg-8">
                                        <Alert bsStyle="danger" className={self.state.errors.length > 0 ? "" : "ap-hidden"}>
                                            <ul className="text-left">
                                                {self.state.errors.map(m =>
                                                    <li key={m}>{m}</li>)}
                                            </ul>
                                        </Alert>
                                    </div>
                                </div>
                                <div className="row" style={rowStyle}>
                                    <div className="col-md-offset-2 col-lg-offset-2 col-md-8 col-lg-8">
                                       <b>All information you submit in this page will be encrypted and sent securely to our system.</b>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Modal show={self.state.showAgreement} dialogClassName="ap-activation-agreement">
                        <Modal.Body className="ap-dialog-body">
                            <div>
                                <div className="row">
                                    <div className="col-md-12 col-lg-12">
                                        <span dangerouslySetInnerHTML={ { __html: self.state.agreement } } />
                                    </div>
                                </div>
                                <div className="row" style={rowStyle}>
                                    <div className="col-md-offset-2 col-lg-offset-2 col-md-8 col-lg-8">
                                        <Button onClick={self.agreeClick} className="btn btn-info ap-fullsize">I AGREE</Button>
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>
                </section>
            </div>
        );
    }
}